import React from 'react';
import { AutocompleteInput, Filter, ReferenceInput, SelectInput, TextInput } from 'react-admin';

import DateInputWrapper from '../../../../Common/Utils/DateInputWrapper';
import Methods from '../StaticData/Methods';

const SearchFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <ReferenceInput source="reference_name" label="Collections" reference="helpers/change_history_collections" allowEmpty>
      <SelectInput label="Collections" source="reference_name" />
    </ReferenceInput>
    <ReferenceInput source="modifier_id" label="Modifier" reference="helpers/users" filter={{ active: true }} sort={{ field: 'last_name', order: 'ASC' }} allowEmpty>
      <AutocompleteInput source="modifier_id" label="Modifier" />
    </ReferenceInput>
    <SelectInput label="Methods" source="method" choices={Methods} />
    <DateInputWrapper source="updated_after" label="Updated After" />
  </Filter>
);

export default SearchFilter;



// WEBPACK FOOTER //
// ./src/views/Components/Reports/ChangeHistory/Helpers/SearchFilter.tsx